import { render, staticRenderFns } from "./treatmentDetail.vue?vue&type=template&id=66f355c4&scoped=true&"
import script from "./treatmentDetail.vue?vue&type=script&lang=js&"
export * from "./treatmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./treatmentDetail.vue?vue&type=style&index=0&id=66f355c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f355c4",
  null
  
)

export default component.exports